import * as React from 'react';

import {
  getAvailability,
  getDrainageCapacity,
  getDrainageType,
  getDrivewayType,
  getElectricityPower,
  getWaterCapacity,
  getWaterType,
} from '../../utils/land_helpers';
import { FOfferType, getOfferType } from '../../utils/offer_type';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import * as styles from './index.css';

export interface ITechnicalCharacterCommercialLandProps {
  offer: IOfferSchema;
}

export class TechnicalCharacterCommercialLand extends React.Component<ITechnicalCharacterCommercialLandProps, {}> {
  public render() {
    const offerType = getOfferType(this.props.offer);

    /**
     * Выводим такие технические характеристики только для коммерческой земли
     */
    if (offerType !== FOfferType.CommercialLand) {
      return null;
    }

    const electricity = getAvailability(this.props.offer, 'electricity');
    const electricityPower = getElectricityPower(this.props.offer);
    const gas = getAvailability(this.props.offer, 'gas');
    const drainage = getAvailability(this.props.offer, 'drainage');
    const drainageType = getDrainageType(this.props.offer);
    const drainageCapacity = getDrainageCapacity(this.props.offer);
    const water = getAvailability(this.props.offer, 'water');
    const waterType = getWaterType(this.props.offer);
    const waterCapacity = getWaterCapacity(this.props.offer);
    const drivewayType = getDrivewayType(this.props.offer);

    if (
      !electricity &&
      !electricityPower &&
      !gas &&
      !drainage &&
      !drainageType &&
      !drainageCapacity &&
      !water &&
      !waterType &&
      !waterCapacity &&
      !drivewayType
    ) {
      return null;
    }

    return (
      <div className={styles['character_land']}>
        <div className={styles['title']}>Технические характеристики</div>
        {(electricity || electricityPower) && (
          <div className={styles['row']}>
            {electricity && (
              <div className={styles['line']}>
                <div className={styles['name']}>Электричество</div>
                <div className={styles['value']}>{electricity}</div>
              </div>
            )}
            {electricityPower && (
              <div className={styles['line']}>
                <div className={styles['name']}>Мощность</div>
                <div className={styles['value']}>{electricityPower}</div>
              </div>
            )}
          </div>
        )}
        {gas && (
          <div className={styles['row']}>
            <div className={styles['line']}>
              <div className={styles['name']}>Газ</div>
              <div className={styles['value']}>{gas}</div>
            </div>
          </div>
        )}
        {(drainage || drainageType || drainageCapacity) && (
          <div className={styles['row']}>
            {drainage && (
              <div className={styles['line']}>
                <div className={styles['name']}>Канализация</div>
                <div className={styles['value']}>{drainage}</div>
              </div>
            )}
            {drainageType && (
              <div className={styles['line']}>
                <div className={styles['name']}>Тип</div>
                <div className={styles['value']}>{drainageType}</div>
              </div>
            )}
            {drainageCapacity && (
              <div className={styles['line']}>
                <div className={styles['name']}>Объём</div>
                <div className={styles['value']}>
                  {drainageCapacity} м<sup>3</sup>/сутки
                </div>
              </div>
            )}
          </div>
        )}
        {(water || waterType || waterCapacity) && (
          <div className={styles['row']}>
            {water && (
              <div className={styles['line']}>
                <div className={styles['name']}>Водоснабжение</div>
                <div className={styles['value']}>{water}</div>
              </div>
            )}
            {waterType && (
              <div className={styles['line']}>
                <div className={styles['name']}>Тип</div>
                <div className={styles['value']}>{waterType}</div>
              </div>
            )}
            {waterCapacity && (
              <div className={styles['line']}>
                <div className={styles['name']}>Объём</div>
                <div className={styles['value']}>
                  {waterCapacity} м<sup>3</sup>/сутки
                </div>
              </div>
            )}
          </div>
        )}
        {drivewayType && (
          <div className={styles['row']}>
            <div className={styles['line']}>
              <div className={styles['name']}>Подъездные пути</div>
              <div className={styles['value']}>{drivewayType}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
